import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Pushes a `page_view` event to GTM dataLayer on every route change.
 * GTM decides whether to fire tags based on Consent Mode state.
 * Skips the initial page load (GTM handles it natively via gtm.js).
 */
export const usePageTracking = () => {
  const location = useLocation();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip initial load — GTM captures the first page view automatically
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    window.dataLayer?.push({
      event: 'page_view',
      page_path: location.pathname,
      page_title: document.title,
      page_location: window.location.href,
    });
  }, [location.pathname]);
};
